<template>
  <base-modal :modal-id="modalId">
    <template v-slot:header>
      <button
        type="button"
        class="d-sm-none btn btn-arrow"
        data-dismiss="modal"
        @click="$bvModal.hide(modalId)"
      >
        <img src="/images/svg/global/left_arrow.svg" />
      </button>

      <h4 class="modal-title mb-0 d-sm-block d-none">
        {{ _T('Change Phone Number') }}
      </h4>
      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Phone Number') }}</h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form">
        <div class="form-group">
          <label>{{ _T('Phone Number') }}</label>
          <phone-number-input
            @custom-input="payload => (phone_number = payload)"
          />
        </div>
        <div class="form-group">
          <label>
            {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order')
            }}{{ ' ' + _T('password') }}
          </label>
          <input
            type="password"
            class="form-control d-sm-block d-none"
            v-model="confirm_password"
          />
          <div class="input-group d-sm-none">
            <input
              type="password"
              class="form-control"
              placeholder="Placeholder"
            />
            <div class="input-group-append">
              <span class="input-group-text">
                <img src="/images/svg/account/eye.svg" />
              </span>
            </div>
          </div>
        </div>
        <div class="btns">
          <button
            type="button"
            class="btn btn-outline"
            data-dismiss="modal"
            @click="closeModal()"
          >
            {{ _T('Cancel') }}
          </button>
          <progress-bar v-if="processInProgress(process)">
            {{ _T('Saving') }}
          </progress-bar>
          <button
            v-else
            type="button"
            class="btn btn-danger"
            data-toggle="modal"
            data-dismiss="modal"
            @click="updateNumber()"
          >
            {{ _T('Save') }}
          </button>
        </div>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/Elements/ProgressBar'
import ValidationMixin from '@/mixins/ValidationMixin'
import { handleApiErrors, validatePhoneNumber } from '@/utils/main_utils.js'
import PhoneNumberInput from '@/components/Elements/PhoneNumberInput.vue'
export default {
  name: 'ChangeNumber',
  components: {
    BaseModal,
    ProgressBar,
    PhoneNumberInput,
  },
  data: () => ({
    confirm_password: '',
    phone_number: '',
    process: 'change-name-avatar',
    modalId: 'change-number',
  }),
  mixins: [ValidationMixin],
  computed: {
    ...mapGetters([
      '_T',
      'web_user',
      'processInProgress',
      'domainBasedBrand',
      '_T_DB',
      'currentBrand',
    ]),
  },
  methods: {
    closeModal() {
      if (this.processInProgress(this.process))
        this.$store.dispatch('stopProcess', this.process)
      this.$bvModal.hide(this.modalId)
    },
    changeNumber() {
      this.$bvModal.hide(this.modalId)
      this.$bvModal.show('verify-number')
    },
    updateNumber() {
      if (!validatePhoneNumber(this.phone_number)) {
        this.$store.dispatch('showNotification', {
          text: this._T('Incorrectly formatted phone number'),
          status: 'error',
        })
        return
      }
      if (this.phone_number == this.web_user.phone_number) {
        this.$store.dispatch('showNotification', {
          text: this._T('Same phone number can not be updated'),
          status: 'error',
        })
        return
      }
      if (!this.phone_number || !this.confirm_password) {
        this.$store.dispatch('showNotification', {
          text: this._T('All fields required'),
          status: 'error',
        })
        return
      }

      if (!this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        const phoneNumber = this.phone_number
          .toString()
          .replace(/\+/g, '')
          .replace(/\s/g, '')
        this.$store
          .dispatch('edit_user_phone', {
            phone_number: phoneNumber,
            confirm_password: this.confirm_password,
            phone_number_verified: false,
          })
          .then(resp => {
            let responseData = resp.data
            if (responseData.status === 'form_errors') {
              let errors = handleApiErrors(responseData.form_errors)
              this.$store.dispatch('showNotification', {
                text: this._T(errors),
                status: 'error',
              })
            } else {
              this.$store.dispatch('showNotification', {
                text: this._T('Record updated successfully'),
                status: 'success',
              })
              this.phone_number = this.web_user.phone_number
              this.$bvModal.hide(this.modalId)
            }
          })
          .catch(() => {
            this.$store.dispatch('showNotification', {
              text: this._T('Your request was not successfull'),
              status: 'error',
            })
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
  },
  mounted() {
    this.phone_number = this.web_user.phone_number
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .edit-profile {
    .modal-body {
      .btns {
        text-align: left;
        .btn {
          + .btn {
            margin-right: $px8;
            margin-left: unset;
          }
        }
      }

      label {
        text-align: right;
        float: right;
      }
    }
  }
}
</style>
